import { useEffect } from 'react';
import { Job } from '@/types/job';

interface SEOJobMetaProps {
  job: Job;
}

export const SEOJobMeta = ({ job }: SEOJobMetaProps) => {
  useEffect(() => {
    // Update document title
    const originalTitle = document.title;
    document.title = `${job.title} bei ${job.company} - Stellenangebote | Scholz Interim`;

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    const originalDescription = metaDescription?.getAttribute('content') || '';
    const description = `${job.title} bei ${job.company} in ${job.location}. ${job.description.replace(/<[^>]*>/g, '').substring(0, 120)}... Jetzt bewerben!`;
    
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    } else {
      const newMeta = document.createElement('meta');
      newMeta.name = 'description';
      newMeta.content = description;
      document.head.appendChild(newMeta);
    }

    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    const originalCanonical = canonical?.href || '';
    const canonicalUrl = `${window.location.origin}/stellenangebote/${job.id}`;
    
    if (canonical) {
      canonical.href = canonicalUrl;
    } else {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      canonical.href = canonicalUrl;
      document.head.appendChild(canonical);
    }

    // Add Open Graph tags
    const addOrUpdateMetaProperty = (property: string, content: string) => {
      let meta = document.querySelector(`meta[property="${property}"]`);
      if (meta) {
        meta.setAttribute('content', content);
      } else {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        meta.setAttribute('content', content);
        document.head.appendChild(meta);
      }
    };

    addOrUpdateMetaProperty('og:title', `${job.title} bei ${job.company}`);
    addOrUpdateMetaProperty('og:description', description);
    addOrUpdateMetaProperty('og:url', canonicalUrl);
    addOrUpdateMetaProperty('og:type', 'article');
    addOrUpdateMetaProperty('og:site_name', 'Scholz Interim - Stellenangebote');
    
    if (job.imageUrl || job.companyLogo) {
      addOrUpdateMetaProperty('og:image', job.imageUrl || job.companyLogo || '');
    }

    // Cleanup function to restore original values
    return () => {
      document.title = originalTitle;
      if (metaDescription) {
        metaDescription.setAttribute('content', originalDescription);
      }
      if (canonical && originalCanonical) {
        canonical.href = originalCanonical;
      }
    };
  }, [job]);

  return null;
};